import { render } from "./vue-alert.html?vue&type=template&id=ee462310&scoped=true&ts=true"
import script from "./vue-alert.ts?vue&type=script&lang=ts"
export * from "./vue-alert.ts?vue&type=script&lang=ts"

import "./vue-alert.scss?vue&type=style&index=0&id=ee462310&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee462310"]])

export default __exports__